import { render, staticRenderFns } from "./jurisdictionBox.vue?vue&type=template&id=7f6cd850&scoped=true&"
import script from "./jurisdictionBox.vue?vue&type=script&lang=js&"
export * from "./jurisdictionBox.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionBox.vue?vue&type=style&index=0&id=7f6cd850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6cd850",
  null
  
)

export default component.exports